import script from "./HallDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HallDetail.vue?vue&type=script&setup=true&lang=js"

import "./HallDetail.vue?vue&type=style&index=0&id=48a5c28a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a5c28a"]])

export default __exports__